
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.container {

  margin-bottom: 1rem;

  display: flex;

  flex-direction: column;

  flex-wrap: wrap;

  justify-content: flex-start;

  gap: 5%
}

@media (min-width: 480px) {

  .container {

    flex-direction: row
  }
}

.metric {

  width: 100%;

  min-width: 8.8rem;

  font-size: var(--fs-base);

  line-height: var(--lh-base)
}

@media (min-width: 480px) {

  .metric {

    width: -moz-min-content;

    width: min-content
  }
}

@media (min-width: 768px) {

  .metric {

    font-size: var(--fs-xs);

    line-height: var(--lh-xs)
  }
}

@media (min-width: 1024px) {

  .metric {

    width: auto
  }

  .metric {

    min-width: -moz-min-content;

    min-width: min-content
  }

  .metric {

    max-width: 30%
  }
}

.metric p {

  margin: 0px
}

.metric .metric-value span {

  font-size: var(--fs-3xl);

  line-height: var(--lh-3xl)
}

.metric .metric-value span {

  font-weight: var(--fw-semibold)
}

@media (min-width: 768px) {

  .metric .metric-value span {

    font-size: var(--fs-4xl);

    line-height: var(--lh-4xl)
  }
}

:host([variant="default"]) .metric {

  color: var(--gray-professional-lighten-1)
}

:host([variant="default"]) .metric-value {

  color: var(--blue-responsible-darken-1)
}

:host([variant="dark"]) .metric, :host([variant="dark"]) .metric-value {

  color: var(--neutral-black)
}

:host([variant="light"]) .metric, :host([variant="light"]) .metric-value {

  color: var(--neutral-white)
}
`;